import { GoalsContent } from "./goalsContent"
import { GoalsProvider } from "./goalsContext"

export function Goals(){
    return(
        <GoalsProvider>
            <GoalsContent/>
        </GoalsProvider>
    )
}